import { render, staticRenderFns } from "./NumTicker.vue?vue&type=template&id=318e7ae2&scoped=true&"
import script from "./NumTicker.vue?vue&type=script&lang=js&"
export * from "./NumTicker.vue?vue&type=script&lang=js&"
import style0 from "./NumTicker.vue?vue&type=style&index=0&id=318e7ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318e7ae2",
  null
  
)

export default component.exports